// opervex-frontend/src/Opervex/axiosController.js

import axios from "axios";
import OpervexStorage from "../utils/OpervexStorage";

class OpervexAPI {
  constructor(tenantId = null) {
    const baseUrl = tenantId ? `${process.env.REACT_APP_API_URL}/${tenantId}` : process.env.REACT_APP_API_URL;

    this.api = axios.create({
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
      },
    });

    this.api.interceptors.request.use(
      (config) => {
        const storedUser = OpervexStorage.getUser();
        if (storedUser?.token) {
          config.headers.Authorization = `Bearer ${storedUser.token}`;
        }

        return config;
      },
      (error) => Promise.reject(error),
    );

    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          OpervexStorage.clear();
          window.location.href = "/login";
        }
        return Promise.reject(error);
      },
    );

    // Interceptador de respostas
    //this.api.interceptors.response.use(
    //  (response) => response,
    //  async (error) => {
    //    if (error.response?.status === 401 && !error.config._retry) {
    //      <Navigate to="/Login" />;

    // console.log("Token expirado ou inválido. Tentando renovar...");
    // error.config._retry = true;
    // const newToken = await this.refreshToken();
    //  if (newToken) {
    //    console.log("Novo token obtido");
    //    error.config.headers.Authorization = `Bearer ${newToken}`;
    //    return this.api(error.config);
    //  }
    //    }

    //    return Promise.reject(error);
    //  },
    //);
  }

  async refreshToken() {
    try {
      const response = await this.api.get("/Refresh");
      const newAccessToken = response.data.accessToken;

      const storedUser = OpervexStorage.getUser();
      if (storedUser) {
        storedUser.token = newAccessToken;
        //localStorage.setItem("_user", JSON.stringify(storedUser));
      }

      return newAccessToken;
    } catch (error) {
      console.error("Erro ao renovar token:", error);
      this.logout();
      return null;
    }
  }

  async get(path, accept = null) {
    const config = {};

    if (accept)
      config.headers = {
        Accept: accept,
      };

    return this.api
      .get(path, config)
      .then((res) => res.data)
      .catch((error) => error.response?.data || error.message);
  }

  async getBinary(path) {
    return this.api
      .get(path, { responseType: "blob" })
      .then((res) => res.data)
      .catch((error) => error.response?.data || error.message);
  }

  async post(path, body) {
    const config = {};
    const isFormData = body instanceof FormData;

    if (isFormData)
      config.headers = {
        "Content-Type": "multipart/form-data",
        Accept: "*/*",
      };

    return this.api
      .post(path, isFormData ? body : JSON.stringify(body), config)
      .then((res) => res.data)
      .catch((error) => {
        if (error?.code === "ERR_NETWORK")
          return { errors: "Erro interno, favor entrar em contato com o administrador se o erro persistir" };
        else return error.response?.data || error.message;
      });
  }

  async put(path, body) {
    return this.api
      .put(path, JSON.stringify(body))
      .then((res) => res.data)
      .catch((error) => {
        if (error?.code === "ERR_NETWORK")
          return { errors: "Erro interno, favor entrar em contato com o administrador se o erro persistir" };
        else return error.response?.data || error.message;
      });
  }

  async delete(path) {
    return this.api
      .delete(path)
      .then((res) => res.data)
      .catch((error) => {
        if (error?.code === "ERR_NETWORK")
          return { errors: "Erro interno, favor entrar em contato com o administrador se o erro persistir" };
        else return error.response?.data || error.message;
      });
  }

  async logout() {
    try {
      await this.api.post("/Logout");
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
    }

    localStorage.removeItem("_user");
    localStorage.removeItem("_roles");
    localStorage.removeItem("_expirationTime");
  }
}

export default OpervexAPI;
